import React from 'react';
import {ListGroup, ListGroupItem, Badge} from 'reactstrap';

const ResultBreakdown = ({resultBD, handleAirlineBD, handleDepBD, handleDesBD, handleRouteBD, airports}) => {
    return (
        <div>
            <div className="mb-5">
                <h6 className="mb-4">Airlines Breakdown</h6>
                <ListGroup>
                    {resultBD.AirlineBD.Items.map((result, i) => {
                        if (i < 5) {
                            return (
                                <span className="text-avi-primary pointer card-link" key={result.Name} onClick={(e) => handleAirlineBD(result)}><ListGroupItem className="justify-content-between">{result.Name} <Badge color="primary" className='btn-avi-primary' pill>{result.ItemValue}</Badge></ListGroupItem></span>)
                        }
                        return '';
                    })}
                </ListGroup>
            </div>
            <div className="mb-5">
                <h6 className="mb-4">Top Departures</h6>
                <ListGroup>
                    {resultBD.DepartureBD.Items.map((result, i) => {
                        if ( i < 5) {
                            let airportName = (airports.Results).filter(option => option.Code === result.Name)[0].Name;
                            return (<span className="text-avi-primary pointer card-link" key={result.Name} onClick={(e) => handleDepBD(result)}><ListGroupItem className="justify-content-between">{airportName} <Badge color="primary" className='btn-avi-primary' pill>{result.ItemValue}</Badge></ListGroupItem></span>)
                        }
                        return ''
                    }
                    )}
                </ListGroup>
            </div>
            <div className="mb-5">
                <h6 className="mb-4">Top Destinations</h6>
                <ListGroup>
                    {resultBD.DestinationBD.Items.map((result, i) => {
                        if ( i < 5) {
                            let airportName = (airports.Results).filter(option => option.Code === result.Name)[0].Name;
                            return (<span className="text-avi-primary pointer card-link" key={result.Name} onClick={(e) => handleDesBD(result)}><ListGroupItem className="justify-content-between">{airportName} <Badge color="primary" className='btn-avi-primary' pill>{result.ItemValue}</Badge></ListGroupItem></span>)
                        }
                        return '';
                    }
                    )}
                </ListGroup>
            </div>
            <div className="mb-5">
                <h6 className="mb-4">Route Breakdown</h6>
                <ListGroup>
                    {resultBD.RouteType.Items.map(result =>
                        <span className="text-avi-primary pointer card-link" key={result.Name} onClick={(e) => handleRouteBD(result)}><ListGroupItem className="justify-content-between">{result.Name} <Badge color="primary" className='btn-avi-primary' pill>{result.ItemValue}</Badge></ListGroupItem></span>
                    )}
                </ListGroup>
            </div>
        </div>
    )
}


export default ResultBreakdown;



// WEBPACK FOOTER //
// ./src/views/search/result-breakdown.js